<template>
  <div class="link-folder-template">
    <!--链接失效的提示界面-->
    <bs-abnormal
      v-if="isForbidden"
      type="linkNoAccess"
    />
    <bs-invalid
      v-else-if="isInvalid"
      :data="data"
    />
    <div
      v-else
      class="isnormal"
    >
      <bs-auth
        v-show="isAuth"
        :data="data"
        @authToken="authToken"
      />
      <!-- 外链文件夹 -->
      <div
        v-show="!isAuth"
        class="link-box"
      >
        <div
          v-show="isSecurity && eodTipH"
          class="link-header-tip"
          :style="{height: `${eodTipH}px`, 'line-height': `${eodTipH}px`}"
        >
          {{ $t('该文件的安全级别较高，您需要下载专用软件才可以使用（仅支持windows用户）') }}<!--
            --><a
          href="/client/eod-Sandbox-plug-in/zBox_eod.rar"
          class="download-area"
        >{{ $t('点击下载') }}</a>{{ $t('软件') }}
          <svg
            class="close-icon"
            @click="closeHeaderTip"
          >
            <use xlink:href="#close" />
          </svg>
        </div>
        <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
        <bs-structure
          :display-right="displayRightPanel"
          :box-margin-r="60"
          :box-margin-l="60"
          :box-right-w="324"
        >
          <!-- header -->
          <template slot="boxHeader">
            <bsHeader
              type="folder"
              :data="data"
            >
              <co-button
                v-show="openRightPanel"
                self-class="right-pannel c-btn"
                @click="toggleRightColumn"
              >
                <template name="default">
                  <svg class="right-pannel-icon">
                    <use :xlink:href="rPanelIcon" />
                  </svg>
                </template>
              </co-button>
            </bsHeader>
          </template>
          <!-- body -->
          <template slot="boxBody">
            <div class="link-box-body">
              <!-- P.S. 这里放预览组件/文件列表组件/异常组件/验证码组件 -->

              <!--导航栏组建，占个位置谁做谁删除了，再写-->
              <div
                ref="navWrapper"
                class="nav-wrapper clearfix"
              >
                <crumb
                  v-if="isShowCrumb"
                  :curb-map="curbMap"
                  :file-list="linkFolder.fileList"
                  :path="linkFolder.path"
                  :crumb-width="crumbWidth"
                  @crumbClick="crumbClick"
                  @goBack="goBack"
                  @refreshCrumb="refreshCrumb"
                />
                <div
                  ref="linkHeaderBtn"
                  class="nav-btn clearfix"
                >
                  <!-- <bs-button
                    v-if="topBtnShow.power.showSavebox && !isSecurity"
                    self-class="s-btn"
                    @click="transferSave"
                  >
                    {{ $t('转存至网盘') }}
                  </bs-button> -->
                  <co-button
                    v-show="topBtnShow.power.showDown && getSelectedData.length === 1 && !getSelectedData[0].data.is_dir"
                    @click="download"
                  >
                    {{ $t('下载') }}
                  </co-button>
                  <co-button
                    v-show="topBtnShow.power.showDown && getSelectedData.length > 1 && !$store.state.curFileInfo.is_checked_watermark"
                    @click="download"
                  >
                    {{ $t('打包下载') }}
                  </co-button>
                  <!--<bs-upload-->
                  <!--v-if="topBtnShow.power.showUpload && this.linkFolder.path=='/'"-->
                  <!--:data="uploadData"-->
                  <!--@after-upload="successBack"-->
                  <!--/>-->
                  <bs-upload
                    v-if="topBtnShow.power.showUpload && linkFolder.path !== '/'"
                    ref="upload"
                    :current-data="linkFolder.fileList"
                    :is-protected="shareInfo.isProtected"
                    :is-show-header="isShowHeader"
                    :folder-dc-type="0"
                    @refreshList="successBack"
                    @showTips="showTips"
                  />
                  <bs-qrcode code-top="42px"
                  :isShowPhone="topBtnShow"
                  />
                </div>
              </div>
              <!--文件列表组件-->
              <link-folder
                ref="linkfolder"
                :file-list="linkFolder.fileList"
                :is-loading="linkFolder.loading"
                :isSecurity="isSecurity"
                @scrollLoadMore="loadMore"
                @doSort="doSort"
                @itemClick="itemClick"
                @operationAction="operationAction"
              />
              <!--外链下载-->
              <iframe
                id="download-iframe"
                src="javascript:false;"
                width="0"
                heigth="0"
                border="none"
                style="display:none"
              />
            </div>
          </template>
          <template slot="boxRight">
            <!--right panel-->
            <div class="link-right">
              <bsLinkRight :data="rightData" />
            </div>
          </template>
        </bs-structure>
      </div>
      <!--dialog-->
      <co-dialog
        v-if="dialog.isShow"
        ref="dilogEl"
        v-model="dialog.isShow"
        :title="dialog.title"
        :show-footer="false"
      >
        <component
          :is="dialogComponent"
          :data="data"
          :selected-data="selectedData"
          :token="linkFolder.requestParam.token"
          @closeDialog="closeDialog"
          @refreshList="successBack"
        />
      </co-dialog>
      <!--上传组件-->
      <bs-base-upload
        ref="dragUpload"
        @after-upload="successBack"
      />
    </div>
  </div>
</template>
<script>
import * as Util from 'js/util/util.js'
import { getAuthToken } from 'components/business/link/auth/fiveMinAuth.js'
import bsAuth from 'components/business/link/auth/index.vue' // 外链提取码页面
import _$ from 'js/api/getdata.js'
import bsAbnormal from 'components/business/abnormal/index.vue'
import Crumb from 'components/business/link/crumb/crumb.vue'
import bsStructure from 'components/business/structure/index.vue'
import bsLinkRight from 'components/business/link/linkright/index.vue'
import bsHeader from 'components/business/link/header/index.vue'
import { getFileList } from 'components/common/folderList/index'
import { sendLogBuryingPointMethods } from 'js/download-service/service-download'
import bsQrcode from 'components/business/qrcode/index.vue'
import coButton from 'components/common/button/index.vue'
import bsUpload from 'components/business/link/privateupload/upload.vue'
import bsBaseUpload from 'components/business/link/upload/upload-base.vue'
import bsInvalid from 'components/business/link/invalid/index.vue'
import { linkDownLoad } from 'js/api/download/linkDown'
import coDialog from 'components/common/dialog/index.vue'
import transferSave from 'components/business/link/transfer/index.vue'
import dndUpload from 'js/api/upload/dnd-upload'
import bsButton from 'components/business/link/lbutton/index.vue'
import { LINKFILE } from 'js/mixin/linkcommon'
import linkFolder from './components/index.vue'

export default {
  components: {
    Crumb,
    bsStructure,
    bsLinkRight,
    bsHeader,
    linkFolder,
    bsQrcode,
    bsAuth,
    coButton,
    coDialog,
    transferSave,
    bsUpload,
    bsBaseUpload,
    bsInvalid,
    bsButton,
    bsAbnormal,
  },
  /**
         * 主要混入的函数
         * sendRecent
         */
  mixins: [LINKFILE],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isShowHeader: true,
      displayRightPanel: true, // 默认展开右侧栏
      // 外联文件请求对象所需要的参数
      linkFolder: {
        fileList: {
          content: [],
        }, // 外联文件数据信息
        offset: 0, // 默认从第0条开始请求数据
        searchSort: { // 默认排序请求规则
          name: 'mtime',
          sortStatus: 2, // 1升序，2降序
        },
        limit: 20, // 每次加载的条目数,
        loading: false, // 请求数据的加载loading,
        path: '/', // 请求外联的级数
        requestParam: { // 请求列表数据的必备参数
          code: '',
          token: '',
        },
      },
      selectedData: [],
      // 面包屑导航对应map
      curbMap: [],
      crumbWidth: 0,
      eodTipH: 0,
      isAuth: false, // 是否要输入提取码,
      isForbidden: false,
      rightData: {},
      dialogComponent: '',
      dialog: {
        isShow: false,
        title: '',
      },
      authData: {}, // 存储有关验证的信息
      topBtnShow: { // 顶部按钮显示控制
        isFirstRequest: true,
        power: {
          showDown: false,
          showUpload: false,
          showSavebox: false,
        },
      },
      isInvalid: false, // 默认链接没有失效
      currentId: '', // 当前的neid
      // 上传数据里需要的数据、
      uploadData: {
        deliveryCode: '',
        token: '',
        neid: '',
        upload_url: '',
        curPath: '',
      },
      // 链接数据
      shareInfo: {
        isSecurity: false, // 安全外链
        isApprove: false, // 审批外链
        isTrial: false, // 体验用户
        isLogin: false, // 是否登录认证
        isProtected: false, // 是否加了提取码
      },
      isShowCrumb: false,
      dirMap: new Map(), // 文件夹路径与相关信息对应关系
    }
  },
  computed: {
    openRightPanel() {
      const param = this.$route.params || {}
      const { neid } = param
      if (neid.length > 32) {
        return false
      }else {
        return true
      }
    },
    rPanelIcon() {
      let icon
      if (this.displayRightPanel) {
        icon = '#retractRightcolumn'
      } else if (this.abnormalType === 'noAccess') {
        icon = '#disExpendRightcolumn'
      } else {
        icon = '#expendRightcolumn'
      }
      return icon
    },
    getSelectedData() {
      if (this.isAuth) {
        return []
      }
      return this.$refs.linkfolder.getSelectFile().data
    },
    code() {
      const param = this.$route.params || {}
      const { neid } = param
      if (neid.length > 32) {
        return false
      }else {
        return true
      }
    },
    isMac() {
      return Util.isMac()
    },
    /**
     * 是否是安全外链
     */
    isSecurity() {
      if (this.shareInfo.isSecurity) this.eodTipH = 44
      return this.shareInfo.isSecurity
    },
  },
  watch: {
    data: {
      handler(n) {
        this.shareInfo.isSecurity = n.ext.security !== 0
        this.shareInfo.isApprove = n.ext.approval !== 0
        this.shareInfo.isLogin = n.ext.islogin
        this.shareInfo.isProtected = n.ext.protected
      },
      immediate: true,
      deep: true,
    },
    // curbMap: {
    //     handler() {
    //         this.$nextTick(() => {
    //             console.log('curbMap')
    //             this.refreshCrumb()
    //         })
    //     },
    //     immediate: true
    // },
    /**
             * 当前目录级别的id,组装uploadData
             */
    currentId(n) {
      this.uploadData.neid = n
      this.uploadData.upload_url = this.linkFolder.fileList.upload_url
    },
    'linkFolder.path': function (n) {
      this.uploadData.curPath = n
    },
  },
  created() {
    // 直接加载数据
    this.init()
    // 注册拖动文件上传的的方法
    dndUpload({ i18n: window.i18n }, (fileData, dataTransferItems) => {
      this.$dragUplaod(fileData, dataTransferItems)
    })
  },
  mounted() {
    // 添加回退历史监听事件
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.goBackByHistory, false)
    }
  },
  destroyed() {
    // 销毁事件
    if (window.history && window.history.pushState) {
      document.removeEventListener('popstate', this.goBackByHistory)
    }
  },
  methods: {
    // 上传抛错
    showTips(msg) {
      window.$toast.simpleShow(msg, 'warn')
    },
    /*
             * 关闭eod header tip
             */
    closeHeaderTip() {
      this.eodTipH = 0
    },
    /** 控制右侧栏 */
    toggleRightColumn() {
      this.displayRightPanel = !this.displayRightPanel
    },
    /**
             *获取顶部文件是否显示
            */
    getTopBtnisShow(data) {
      const param = this.$route.params || {}
      const { neid } = param
      /**
       *
       * topBtnShow: { // 顶部按钮显示控制
        isFirstRequest: true,
        power: {
          showDown: false,
          showUpload: false,
          showSavebox: false,
        },
      },
       */
      if (neid.length > 32) {
        this.topBtnShow.power.showDown = false
        this.topBtnShow.power.showSavebox = false
      } else {
        this.topBtnShow.isFirstRequest = false
        const power = data.access_mode
        if (/download/.test(power)) {
          this.topBtnShow.power.showDown = true
          this.topBtnShow.power.showSavebox = true
        }
        if (/upload/.test(power)) this.topBtnShow.power.showUpload = true
      }
    },
    /** 下载 */
    download() {
      if (this.linkFolder.fileList.content.length < 0) {
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      const selectData = this.$refs.linkfolder.getSelectFile().data.map((value) => value.data)
      if (selectData.length <= 0) {
        this.$toast.simpleShow('请您先选择文件', 'warn')
      } else {
        // // 处理外部文件数据
        // const data = []
        // selectData.forEach((item) => {
        //   data.push(item.data)
        // })
        // 下载数据
        linkDownLoad(this.shareInfo, this.$store.state.curFileInfo, selectData)
      }
    },
    /**
             * 验证组件验证通过后，emit的事件
             */
    async authToken(data) {
      this.authData = data
      const params = {
        token: data.token,
      }
      this.init(params) // token验证
    },
    /**
             * 初始化
             * @param {Object} paramData为getmetadata的参数中的token
             */
    async init(paramData) {
      const params = paramData || {} // getMetaData的参数
      if (this.data.ext.protected) { // 判断是否需要输入提取码
        if (!params.token) { // 是否已有验证获取的token
          const tokenRes = getAuthToken(this.data.deliverycode) // 5分中内的判断
          this.authData.token = tokenRes.token
          this.authData.password = tokenRes.password
          if (!tokenRes.hasToken) {
            this.isAuth = true
            return
          }
          params.token = tokenRes.token
        }
      }
      // 重新设置请求path的分层级别
      if (sessionStorage.getItem(`ListPath_${this.data.deliverycode}`) != '' && sessionStorage.getItem(`ListPath_${this.data.deliverycode}`) != undefined) {
        // 没有面包屑暂时不存储的localStorage
        this.linkFolder.path = sessionStorage.getItem(`ListPath_${this.data.deliverycode}`)
        // 重新设置面包屑导航
        this.curbMap = JSON.parse(sessionStorage.getItem(`crum-${this.data.deliverycode}`))
        // 还原对应关系
        this.dirMap = new Map(JSON.parse(sessionStorage.getItem(`dirMap-${this.data.deliverycode}`)))
        this.linkFolder.neid = this.dirMap.get(this.linkFolder.path) && this.dirMap.get(this.linkFolder.path).neid
      }
      this.linkFolder.requestParam.code = this.data.deliverycode
      this.linkFolder.requestParam.token = params.token
      // 记录上传的token和code
      this.uploadData.deliveryCode = this.data.deliverycode
      this.uploadData.token = params.token ? params.token : ''

      // 请求数据
      this.getLinkFileList()
    },
    /**
             * 获取当前面包屑宽度
             */
    getCrumbWidth() {
      if (this.$refs.linkHeaderBtn && this.$refs.navWrapper) {
        let btnMarginLeft = 0
        let navPaddingLeft = 0
        let navPaddingRight = 0
        if (window.getComputedStyle) {
          btnMarginLeft = +window.getComputedStyle(this.$refs.linkHeaderBtn)['margin-left'].replace('px', '')
          navPaddingLeft = +window.getComputedStyle(this.$refs.navWrapper)['padding-left'].replace('px', '')
          navPaddingRight = +window.getComputedStyle(this.$refs.navWrapper)['padding-right'].replace('px', '')
        }
        const parentWidth = this.$refs.navWrapper.offsetWidth - navPaddingLeft - navPaddingRight
        const btnWidth = this.$refs.linkHeaderBtn.offsetWidth + btnMarginLeft
        return parentWidth - btnWidth
      }
    },
    /**
             * 窗口变化回调函数
             */
    refreshCrumb() {
      this.crumbWidth = this.getCrumbWidth()
    },
    /**
             * 滚动加载更多数据
             */
    loadMore() {
      // 请求数据
      this.getLinkFileList(true, false)
    },
    /**
             * 排序加载数据
             */
    doSort(data) {
      // 重置排序规则
      this.linkFolder.searchSort = data
      // 重置下标为0
      this.linkFolder.offset = 0
      // 现在测试默认就直接加载
      this.getLinkFileList(false, false)
    },
    /**
             *列表点击事件
            */
    itemClick(data) {
      // 判断试文件还是文件夹
      if (data.isDir) {
        // 请求文件夹下的数据
        this.linkFolder.offset = 0 // 重置下标
        // 计算路径的path
        this.linkFolder.path = data.path
        this.linkFolder.neid = data.neid
        // 请求数据
        this.getLinkFileList()
      } else {
        // 重新打开进入预览文件的界面
        this.goPreviewPage(data)
      }
    },
    // 判断文件的大小限制
    async checkFileLimit(data) {
      const vm = this
      const param = {
        neid: data.neid,
        nsid: data.nsid,
      }
      const privilegeState = Util.getPrivatePrivilege(data.access_mode) // access_mode 被修饰过，已经不是Number，是“preview_upload_download"
      // eslint-disable-next-line no-return-await
      return await _$.getData('previewFileLimit', param).then((res) => {
        const checkData = res.data
        if (data && !checkData.checkSizeResult) { // 已超限
          const limitSize = Util.formatBytes(checkData.previewSizeLimit)
          if (privilegeState && privilegeState.canDownload) { // 有下载权限
            vm.$confirm.show({
              value: true,
              isShow: true,
              onlyOne: false,
              title: '提示',
              sureBtn: '下载',
              isDescribe: true,
              describe: `<span style="font-size:14px;color:#637282;display: inline-block;margin-top:4px;margin-bottom: 10px;">${this.$t('为了提供稳定的预览体验，目前仅支持下载查看')}</span>`,
              content: `<span style="font-size:16px;color:#1B2733;">${this.$t('该文档大小超过{n}暂不支持在线预览', { n: limitSize })}</span>`,
              sure() {
                vm.download()
                vm.$confirm.hide()
              },
            })
            return false
          }
          vm.$confirm.show({ // 无下载权限
            value: true,
            isShow: true,
            onlyOne: true,
            title: '提示',
            isDescribe: true,
            sureBtn: '知道了',
            describe: `<span style="font-size:14px;color:#637282;display: inline-block;margin-top:4px;margin-bottom: 10px;">${this.$t('为了提供稳定的预览体验，目前仅支持下载查看')}</span>
                                        <span>${this.$t('如果您没有下载权限，请联系文件授权者或者系统管理员')}</span>`,
            content: `<span style="font-size:16px;color:#1B2733;">${this.$t('该文档大小超过{n}暂不支持在线预览', { n: limitSize })}</span>`,
            sure() {
              vm.$confirm.hide()
            },
          })
          return false
        }
        return true
      }).catch((err) => {
        // 如果接口500，那预览就跳不过去了，所以当保存时，先让用户跳过去，预览页中也有拦截
        if (err.response && err.response.status.toString().indexOf('50') >= 0) {
          return true
        }
      })
    },
    /**
             * 进入外链预览界面
             */
    async goPreviewPage(data, openNew = true) {
      // 判断是否为体验用户，体验用户无法预览
      if (this.shareInfo.isTrial) {
        this.$toast.simpleShow('体验版本不支持在线预览，请升级版本', 'warn')
        return
      }
      const limitPass = await this.checkFileLimit(data) // 检验大小限制是否pass
      // 重新打开进入预览文件的界面,文件在边界范围内，文件支持预览，文件含有预览权限
      if (/^preview/.test(data.access_mode) && limitPass && Util.suppportPreview(data)) {
        let deliveryCode = this.linkFolder.requestParam.code
        if (deliveryCode.length > 32) {
          deliveryCode = deliveryCode.substring(5, deliveryCode.length)
        }
        const { href } = this.$router.resolve({
          name: 'linkfile',
          params: {
            neid: data.neid,
          },
          query: {
            other: JSON.stringify({
              neid: this.currentId,
              nsid: data.nsid,
              metadata_url: data.metadata_url,
              token: this.authData.token,
              password: this.$jsEncrypt.encrypt(this.authData.password),
              code: deliveryCode,
              // offset: this.linkFolder.offset,
              orderby: this.linkFolder.searchSort.name,
              sort: this.linkFolder.searchSort.sortStatus == '1' ? 'asc' : 'desc',
              // limit: this.linkFolder.limit
            }),
            requestParam:JSON.stringify(data.requestParam)
          },
        })
        // 记日志
        if (this.shareInfo.isLogin) {
          sendLogBuryingPointMethods({
            category: 4,
            action: 404,
            pathType: this.$store.state.curFileInfo.path_type,
            entityStr1: data.neid,
            nsid: data.nsid,
          })
        }
        openNew ? window.open(href, '_blank') : window.open(href)
      }
    },
    // 根据path刷新列表
    refreshListData(data, index) {
      this.curbMap = this.curbMap.slice(0, +index + 1)
      this.resetNewList(data)
      this.getLinkFileList()
    },
    /**
             * 清空列表配置数据
             */
    resetNewList(data) {
      this.linkFolder.fileList.content = []
      this.linkFolder.path = data.path
      this.linkFolder.neid = data.neid
      this.linkFolder.offset = 0
    },
    /**
             * 面包屑点击
             */
    crumbClick(value) {
      // 存储当前路径
      sessionStorage.setItem(`crum-${this.data.deliverycode}`, JSON.stringify(this.curbMap))
      const { data, index } = value
      if (index) {
        this.refreshListData(data, index)
      }
    },
    /**
             * 返回上一个操作
             */
    goBack() {
      history.back()
    },
    /**
             * 面包屑导航的对应关系
             */
    crubPathMap(path, rpath, neid) {
      if (this.dirMap && !this.dirMap.has(path)) {
        this.dirMap.set(path, {path, rpath, neid})
        sessionStorage.setItem(`dirMap-${this.data.deliverycode}`, JSON.stringify([...this.dirMap]))
      }
      this.curbMap = this.curbMap.filter((item) => item.path != path)
      this.curbMap.push({ path, rpath, neid })
      sessionStorage.setItem(`crum-${this.data.deliverycode}`, JSON.stringify(this.curbMap))
    },
    /**
             * 获取外链文件夹信息
             * @param isScrollLoad Boolean 是否滚动加载数据
             * @param saveHistory Boolean 默认存储history历史
             */
    getLinkFileList(isScrollLoad = false, saveHistory = true) {
      const { searchSort } = this.linkFolder // Obejct 排序规则
      const { offset } = this.linkFolder // 从哪一条数据开始请求
      const { limit } = this.linkFolder // 每次请求条目数
      const { path } = this.linkFolder // 是否为根目录
      const { neid } = this.linkFolder // 文件夹neid
      // 真实的请求路径
      let nPath = '/'
      if (path.split('/').length > 2) {
        nPath = path.indexOf('/', 1) === '-1' ? '/' : path.substring(path.indexOf('/', 1), path.length)
      }
      // 存储面包屑导航对应关系
      this.crubPathMap(path, nPath, neid)
      let { code } = this.linkFolder.requestParam
      const token = this.linkFolder.requestParam.token ? `token=${this.linkFolder.requestParam.token}&` : '' // 用户输入密码后的token
      // 设置排序模式
      const sort = searchSort.sortStatus === 1 ? 'asc' : 'desc'
      // 请求地址
      if (code.length > 32) {
        code = code.substring(5, code.length)
      }
      let url = `/v2/delivery/metadata/${code}?${token}orderby=${searchSort.name}&sort=${sort}&offset=${offset}&limit=${limit}&_=${Date.parse(new Date())}&interface_version=2020`
      if (neid) {
        url += `&neid=${neid}`
      }
      // 开启加载的loading
      this.linkFolder.loading = true
      // 请求数据
      _$.getUrl(url).then((res) => {
        res.data.content = res.data.content.map((item,index)=>{
          return {
            ...item,
            checked: false,
            requestParam: {
              index,
              code,
              token: this.linkFolder.requestParam.token || '',
              sort,
              offset,
              limit,
              orderby:searchSort.name,
              neid
            }
          }
        })
        this.$store.commit('GET_CUR_FILE_INFO', res.data)
        // 当前目录级别id
        this.currentId = res.data.neid
        // 设置右侧数据信息
        if (Object.keys(this.rightData).length <= 0) {
          this.rightData = res.data
          this.rightData.delivery_ad = (this.data.ext && this.data.ext.deliveryAd) == '1' || false
          const content = res.data
          const deliveryInfo = { // 外链文件最近访问信息
            neid: content.neid || '',
            nsid: content.nsid || '',
            deliverycreator: content.delivery_creator,
            deliveryfilename: content.path ? content.path.substring(1) : '',
            delivery_ctime: content.delivery_mtime,
            expiration: Util.formatDate(content.expiration, 'yyyy-MM-dd hh:mm'),
            deliverydescription: content.delivery_desc,
            deliveryId: this.data.deliverycode,
          }
          this.sendRecent(deliveryInfo) // 刚进来时，只记录一次 最近访问
        }
        // 如果为根路径,则返回值就是content
        if (path == '/') {
          // 计算是否为病毒文件，并赋值给根
          const isvirus = res.data.content.find((item) => item.isvirus == true)
          res.data.isvirus = !!isvirus
          delete res.data.content
          res.data.content = [{ ...res.data }]
          res.data.path = '/'
        }
        // 重新组合返回数据
        getFileList(res.data, (resolve) => {
          // 设置顶部按钮权限,
          if (this.topBtnShow.isFirstRequest) { this.getTopBtnisShow(res.data) }
          // 定义安全检验方法
          function checkRule(ruleItem) {
            if (ruleItem === undefined || ruleItem === true) {
              return true
            }
            return false
          }
          // 审批外链
          if (this.data.isApprove) {
            // 进行安全管控文件之后在拼接数据
            for (let i = 0, len = resolve.content.length; i < len; i++) {
              const item = resolve.content[i]
              // 链接安全管控：上传，下载，预览，内部成员，最长有效期，五个全部通过则显示该文件夹
              if (item.isDir
                                    && !(checkRule(item.ruleShowUploadFolder)
                                        && checkRule(item.ruleShowDownloadFolder)
                                        && checkRule(item.ruleShowPreviewFolder)
                                        && checkRule(item.ruleShowStaffOnlyFolder)
                                        && checkRule(item.ruleShowMaxValidFolder)
                                    )) { // 该文件夹无法显示
                resolve.content.splie(i, 1)
              }
            }
          }
          // 判断是否滚动
          if (isScrollLoad) {
            this.linkFolder.fileList.content = this.linkFolder.fileList.content.concat(resolve.content)
            // 重新设置offset
            this.linkFolder.offset = this.linkFolder.offset + resolve.content.length
          } else {
            // 清空选中数据,确保改组件在被初始化的情况下
            if (this.$refs.linkfolder) this.$refs.linkfolder.clearSelect()
            // 切换页面时滚动条自动滚动到顶部
            if (document.getElementById('virtual-scroll-wrapper') != null && this.linkFolder.fileList.content.length > 0) {
              document.getElementById('virtual-scroll-wrapper').scrollTop = 0
            } else if (this.linkFolder.fileList.content.length > 0) {
              document.getElementById('scroll-wrapper').scrollTop = 0
            }
            // 重新设置加载文件数
            this.linkFolder.fileList = resolve
            // 重新设置offset
            this.linkFolder.offset = resolve.content.length
          }
          // 查看filelist打印
          // console.log(this.linkFolder.fileList, 'fileList')
          // this.isShowCrumb = false
          this.$nextTick(() => {
            this.crumbWidth = this.getCrumbWidth()
            this.isShowCrumb = true
            this.getNeids()
          })
        })
        // 关闭loading
        this.linkFolder.loading = false
        // 设置当前的path,并保证下次的刷新为当前路径
        this.linkFolder.path = res.data.path
        sessionStorage.setItem(`ListPath_${this.data.deliverycode}`, this.linkFolder.path)
        // 存储返回history历史,兼容ie9没有pushState问题。
        if ((window.history && window.history.pushState) && saveHistory) {
          // 支持History API
          window.history.pushState({ path: this.linkFolder.path, neid: this.linkFolder.neid }, null, this.linkFolder.requestParam.code)
        }
        // 隐藏提取码界面
        this.isAuth = false
      }).catch((error) => {
        // 请求异常...
        if (error.response && (error.response.status === 403 || error.response.status === 404)) {
          // this.error400 = true; //显示错误页面，显示外链失效界面
          if (error.response.data && error.response.data.state === 403 && error.response.data.code === 'forbidden') {
            this.isForbidden = true
            return
          }
          if (error.response.status === 403) {
            this.isAuth = true
            return
          }
          // 跳转到链接失效界面
          this.data.abnormalType = 'invalidLose'
          this.isInvalid = true
        }
      })
    },
    /**
             * 返回历史操作
             */
    goBackByHistory(event) {
      if (event.state == null) {
        window.location.reload()
      } else {
        // 重置导航
        const crubList = []
        if (event.state.path != '/') {
          event.state.path.split('/').forEach((item, index, arr) => {
            if (index == 0) {
              crubList.push({ path: `/`, rpath: `/`, neid: undefined })
            } else {
              const path = arr.slice(0, index + 1).join('/')
              const map = this.dirMap.get(path)
              crubList.push({ path: path, rpath: map && map.rpath, neid: map && map.neid })
            }
          })
        }
        this.curbMap = crubList
        this.resetNewList(event.state)
        this.getLinkFileList(false, false)
      }
    },
    /**
             * 列表按钮的点击事件
             */
    operationAction({ name, operateType, selectData }) {
      switch (name) {
        // eslint-disable-next-line no-case-declarations
        case 'download':
          // 处理外部文件数据
          const data = []
          selectData.data.forEach((item) => {
            data.push(item.data)
          })
          console.log(data)
          linkDownLoad(this.shareInfo, this.$store.state.curFileInfo, data)
          break
        case 'savetobox':
          this.transferSave()
          break
        case 'preview':
          this.goPreviewPage(selectData.data['0'].data)
          break
        default:
          break
      }
    },
    /**
             * 转存
             */
    transferSave() {
      // 验证保存
      this.selectedData = this.$refs.linkfolder.getSelectFile().data
      if (!this.selectedData || this.selectedData.length === 0) {
        this.$toast.simpleShow('请选择将要保存的文件', 'warn')
        return
      }
      if (this.selectedData.length > 100) {
        window.$confirm.show({
          value: true,
          isShow: true,
          onlyOne: true,
          title: '提示',
          sureBtn: '确定',
          content: '批量操作数量不能超过100',
          sure() {
            window.$confirm.hide()
          },
        })
        return false
      }
      // 判断用户是否登录
      _$.getData('getUserInfo').then((res) => {
        if (res.data.state === 401) {
          this.saveNeids()
          Util.gotoLogin()
        } else {
          sessionStorage.removeItem('openSave')
          this.dialogComponent = 'transferSave'
          this.dialog.isShow = true
          this.dialog.title = this.$t('转存至网盘')
        }
      }).catch(() => {
        this.saveNeids()
        Util.gotoLogin()
      })
    },
    /**
             * 获取选中数据的neid
             */
    getNeids() {
      if (this.data.ext.islogin) {
        const neids = JSON.parse(sessionStorage.getItem('openSave'))
        if (neids) {
          this.$refs.linkfolder.setSelectFile(neids)
          this.$nextTick(() => {
            this.transferSave()
          })
        }
      }
    },
    /**
             * 存储选中数据的neid
             */
    saveNeids() {
      let result = []
      if (!this.selectedData) result = []
      result = this.selectedData.map((v, i) => v.data.neid)
      sessionStorage.setItem('openSave', JSON.stringify(result))
    },
    /**
             * 关闭弹框
             */
    closeDialog() {
      this.dialog.isShow = false
    },
    /**
             * 上传成功后的回调事件
             */
    successBack() {
      // 重新刷新当前目录级列表，从0-50开始
      // 重置下标为0
      this.linkFolder.offset = 0
      // 现在测试默认就直接加载
      this.getLinkFileList(false, false)
    },
    /**
             * 恢复之前的转存弹框
             */
    recoverTransfer() {

    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/link.less';

.link-header-tip{
  font-size: 14px;
  line-height: 20px;
  position: relative;
  .download-area{
    color: #005EFE;
  }
  .close-icon{
    width: 14px;
    height: 14px;
    vertical-align: middle;
    position: absolute;
    top: 50%;
    right: 0px;
    margin-top: -7px;
    margin-right: 24.6px;
    cursor: pointer;
  }
}
.box-header{
  .right-pannel{
    min-width: 32px;
    padding: 0;
    margin-top: 9px;
    margin-right: 20px;
    float:right;
    .right-pannel-icon{
      width: 24px;
      height: 24px;
      vertical-align: -6px;
      display: inline-block;
    }
  }
  .eod-download{
    margin-top: 9px;
    float: right;
    .eod-download-icon{
      width: 20px;
      height: 20px;
      float: left;
      margin-top: 6px;
    }
  }
}

.nav-wrapper{
  // // width: 910px;
  // height: 32px;
  // box-sizing: border-box;
  background-color: #fff;
  padding: 31px 24px 21px 60px;
  height: 32px;
}
.nav-btn{
  // margin-left: 24px;
  // float: right;
  position: absolute;
  right: 24px;
  top: 32px;
  margin-left: 24px;
  // float: right;
  height: 32px;
  box-sizing: border-box;
}

.link-box{
  width: 100%;
  height: 100%;
}

.link-right{
  #link-right{
    width: 100%;
  }
}

.link-folder-template{
  width: 100%;
  height: 100%;
}

.isnormal {
  width: 100%;
  height: 100%;
}
</style>
